

// import React, { useEffect, useState } from 'react';
// import './formreport.css';
// import axios from 'axios';
// import html2pdf from 'html2pdf.js';
// import { FaCalendarAlt, FaTags, FaFilter, FaDownload, FaListUl, FaChevronDown, FaChevronUp } from 'react-icons/fa';

// const ExpensesReport = () => {
//   const [reportType, setReportType] = useState(() => localStorage.getItem('reportType') || 'daily');
//   const [viewMode, setViewMode] = useState(() => localStorage.getItem('viewMode') || 'regular'); // NEW filter
//   const [fromDate, setFromDate] = useState(() => localStorage.getItem('fromDate') || '');
//   const [toDate, setToDate] = useState(() => localStorage.getItem('toDate') || '');
//   const [categoryFilter, setCategoryFilter] = useState(() => localStorage.getItem('categoryFilter') || 'All');
//   const [reportData, setReportData] = useState([]);
//   const [expandedRows, setExpandedRows] = useState({}); // for expand/collapse

//   useEffect(() => {
//     localStorage.setItem('reportType', reportType);
//     localStorage.setItem('viewMode', viewMode);
//     localStorage.setItem('fromDate', fromDate);
//     localStorage.setItem('toDate', toDate);
//     localStorage.setItem('categoryFilter', categoryFilter);
//   }, [reportType, viewMode, fromDate, toDate, categoryFilter]);

//   const fetchReport = async () => {
//     try {
//       const response = await axios.get('https://kmtea.onrender.com/expensesget');
//       let rawData = response.data;

//       const from = fromDate ? new Date(fromDate) : null;
//       const to = toDate ? new Date(toDate) : null;

//       rawData = rawData.filter(item => {
//         const itemDate = new Date(item.date);
//         if (from && itemDate < from) return false;
//         if (to && itemDate > to) return false;
//         return true;
//       });

//       rawData = rawData.map(item => ({
//         ...item,
//         category: item.category || 'Others'
//       }));

//       if (categoryFilter !== 'All') {
//         rawData = rawData.filter(item =>
//           categoryFilter === 'Others'
//             ? !['Petrol Allowance', 'Tea Allowance', 'Driver Allowance'].includes(item.category)
//             : item.category === categoryFilter
//         );
//       }

//       const grouped = groupData(rawData, reportType, viewMode);
//       setReportData(grouped);
//     } catch (error) {
//       console.error('Error fetching report:', error);
//     }
//   };

//   const groupData = (data, type, mode) => {
//     const groupBy = (items, keyFunc) => {
//       return items.reduce((result, item) => {
//         const key = keyFunc(item);
//         if (!result[key]) result[key] = [];
//         result[key].push(item);
//         return result;
//       }, {});
//     };

//     const getKey = (item) => {
//       const date = new Date(item.date);
//       switch (type) {
//         case 'weekly': {
//           const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
//           const dayOfMonth = date.getDate();
//           const weekOfMonth = Math.ceil((dayOfMonth + firstDayOfMonth.getDay()) / 7);
//           const monthName = date.toLocaleString('default', { month: 'short' });
//           return `Week ${weekOfMonth} - ${monthName} ${date.getFullYear()}`;
//         }
//         case 'monthly':
//           return `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
//         case 'daily':
//         default:
//           return date.toLocaleDateString('en-GB');
//       }
//     };

//     const grouped = Object.entries(groupBy(data, getKey)).map(([dateKey, items]) => {
//       if (mode === 'total') {
//         const totalAmount = items.reduce((sum, item) => sum + Number(item.amount || 0), 0);
//         const allDescriptions = items.map(i => `${i.category}: ${i.description || '—'}`);
//         return {
//           date: dateKey,
//           category: 'Mixed',
//           totalAmount,
//           descriptions: allDescriptions
//         };
//       }
//       return { date: dateKey, items };
//     });

//     return grouped;
//   };

//   const handleDownload = () => {
//     const element = document.querySelector('.farmer-report__table-container');
//     html2pdf().from(element).save('ExpensesReport.pdf');
//   };

//   const getCategoryClass = (category) => {
//     switch (category) {
//       case 'Petrol Allowance': return 'tag tag-petrol';
//       case 'Tea Allowance': return 'tag tag-tea';
//       case 'Driver Allowance': return 'tag tag-driver';
//       default: return 'tag tag-other';
//     }
//   };

//   const toggleRow = (index) => {
//     setExpandedRows(prev => ({
//       ...prev,
//       [index]: !prev[index]
//     }));
//   };

//   return (
//     <div className="farmer-report__container">
//       <h2>Expenses Report</h2>

//       <div className="farmer-report__filters">
//         <div className="filter-group">
//           <FaFilter className="filter-icon" />
//           <select value={reportType} onChange={(e) => setReportType(e.target.value)}>
//             <option value="daily">Daily</option>
//             <option value="weekly">Weekly</option>
//             <option value="monthly">Monthly</option>
//           </select>
//         </div>

//         <div className="filter-group">
//           <FaListUl className="filter-icon" />
//           <select value={viewMode} onChange={(e) => setViewMode(e.target.value)}>
//             <option value="regular">Regular</option>
//             <option value="total">Total</option>
//           </select>
//         </div>

//         <div className="filter-group">
//           <FaTags className="filter-icon" />
//           <select value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}>
//             <option value="All">All</option>
//             <option value="Petrol Allowance">Petrol Allowance</option>
//             <option value="Tea Allowance">Tea Allowance</option>
//             <option value="Driver Allowance">Driver Allowance</option>
//             <option value="Others">Others</option>
//           </select>
//         </div>

//         <div className="filter-group date-label">
//           <FaCalendarAlt className="filter-icon" />
//           <label>
//             From:
//             <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//           </label>
//         </div>

//         <div className="filter-group date-label">
//           <FaCalendarAlt className="filter-icon" />
//           <label>
//             To:
//             <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
//           </label>
//         </div>

//         <button onClick={fetchReport}>Get Report</button>
//         <button onClick={handleDownload} style={{ background: '#28a745' }}>
//           <FaDownload /> Download
//         </button>
//       </div>

//       {reportData.length > 0 ? (
//         <div className="farmer-report__table-container">
//           <table className="farmer-report__table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Category</th>
//                 <th>Description</th>
//                 <th>Amount</th>
//               </tr>
//             </thead>
//             <tbody>
//               {viewMode === 'regular' ? (
//                 reportData.map((group, index) =>
//                   group.items.map((entry, idx) => (
//                     <tr key={`${index}-${idx}`}>
//                       <td>{group.date}</td>
//                       <td><span className={getCategoryClass(entry.category)}>{entry.category}</span></td>
//                       <td>{entry.description || '—'}</td>
//                       <td>{entry.amount}</td>
//                     </tr>
//                   ))
//                 )
//               ) : (
//                 reportData.map((group, index) => (
//                   <React.Fragment key={index}>
//                     <tr>
//                       <td>{group.date}</td>
//                       <td><span className="tag tag-mixed">Mixed</span></td>
//                       <td>
//                         <button
//                           className="expand-btn"
//                           onClick={() => toggleRow(index)}
//                         >
//                           {expandedRows[index] ? <FaChevronUp /> : <FaChevronDown />} View Details
//                         </button>
//                         {expandedRows[index] && (
//                           <ul className="description-list">
//                             {group.descriptions.map((desc, i) => (
//                               <li key={i}>{desc}</li>
//                             ))}
//                           </ul>
//                         )}
//                       </td>
//                       <td><strong>{group.totalAmount}</strong></td>
//                     </tr>
//                   </React.Fragment>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <div className="farmer-report__no-data">No report data available.</div>
//       )}
//     </div>
//   );
// };

// export default ExpensesReport;


import React, { useEffect, useState, useMemo } from 'react';
import './formreport.css';
import axios from 'axios';
import html2pdf from 'html2pdf.js';
import {
  FaCalendarAlt,
  FaTags,
  FaFilter,
  FaDownload,
  FaListUl,
  FaChevronDown,
  FaChevronUp
} from 'react-icons/fa';

const ExpensesReport = () => {
  const [reportType, setReportType] = useState(() => localStorage.getItem('reportType') || 'daily');
  const [viewMode, setViewMode] = useState(() => localStorage.getItem('viewMode') || 'regular');
  const [fromDate, setFromDate] = useState(() => localStorage.getItem('fromDate') || '');
  const [toDate, setToDate] = useState(() => localStorage.getItem('toDate') || '');
  const [categoryFilter, setCategoryFilter] = useState(() => localStorage.getItem('categoryFilter') || 'All');
  const [reportData, setReportData] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    localStorage.setItem('reportType', reportType);
    localStorage.setItem('viewMode', viewMode);
    localStorage.setItem('fromDate', fromDate);
    localStorage.setItem('toDate', toDate);
    localStorage.setItem('categoryFilter', categoryFilter);
  }, [reportType, viewMode, fromDate, toDate, categoryFilter]);

  const fetchReport = async () => {
    try {
      const response = await axios.get('https://kmtea.onrender.com/expensesget');
      let rawData = response.data;

      const from = fromDate ? new Date(fromDate) : null;
      const to = toDate ? new Date(toDate) : null;

      rawData = rawData.filter(item => {
        const itemDate = new Date(item.date);
        if (from && itemDate < from) return false;
        if (to && itemDate > to) return false;
        return true;
      });

      rawData = rawData.map(item => ({
        ...item,
        category: item.category || 'Others'
      }));

      if (categoryFilter !== 'All') {
        rawData = rawData.filter(item =>
          categoryFilter === 'Others'
            ? !['Petrol Allowance', 'Tea Allowance', 'Driver Allowance'].includes(item.category)
            : item.category === categoryFilter
        );
      }

      setReportData(groupData(rawData, reportType, viewMode));
    } catch (error) {
      console.error('Error fetching report:', error);
    }
  };

  const groupData = (data, type, mode) => {
    const groupBy = (items, keyFunc) =>
      items.reduce((res, item) => {
        const key = keyFunc(item);
        res[key] = res[key] || [];
        res[key].push(item);
        return res;
      }, {});

    const getKey = item => {
      const date = new Date(item.date);
      if (type === 'weekly') {
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const week = Math.ceil((date.getDate() + firstDay.getDay()) / 7);
        return `Week ${week} - ${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
      }
      if (type === 'monthly') {
        return `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
      }
      return date.toLocaleDateString('en-GB');
    };

    return Object.entries(groupBy(data, getKey)).map(([date, items]) =>
      mode === 'total'
        ? {
            date,
            totalAmount: items.reduce((s, i) => s + Number(i.amount || 0), 0),
            descriptions: items.map(i => `${i.category}: ${i.description || '—'}`)
          }
        : { date, items }
    );
  };

  /* ✅ GRAND TOTAL (FILTER-AWARE) */
  const grandTotal = useMemo(() => {
    if (viewMode === 'total') {
      return reportData.reduce((sum, g) => sum + Number(g.totalAmount || 0), 0);
    }
    return reportData.reduce(
      (sum, g) => sum + g.items.reduce((s, i) => s + Number(i.amount || 0), 0),
      0
    );
  }, [reportData, viewMode]);

  const handleDownload = () => {
    html2pdf().from(document.querySelector('.farmer-report__table-container')).save('ExpensesReport.pdf');
  };

  const getCategoryClass = category => {
    if (category === 'Petrol Allowance') return 'tag tag-petrol';
    if (category === 'Tea Allowance') return 'tag tag-tea';
    if (category === 'Driver Allowance') return 'tag tag-driver';
    return 'tag tag-other';
  };

  const toggleRow = index =>
    setExpandedRows(prev => ({ ...prev, [index]: !prev[index] }));

  return (
    <div className="farmer-report__container">
      <h2>Expenses Report</h2>

      {/* FILTERS */}
      <div className="farmer-report__filters">
        <select value={reportType} onChange={e => setReportType(e.target.value)}>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>

        <select value={viewMode} onChange={e => setViewMode(e.target.value)}>
          <option value="regular">Regular</option>
          <option value="total">Total</option>
        </select>

        <select value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)}>
          <option value="All">All</option>
          <option value="Petrol Allowance">Petrol Allowance</option>
          <option value="Tea Allowance">Tea Allowance</option>
          <option value="Driver Allowance">Driver Allowance</option>
          <option value="Others">Others</option>
        </select>

        <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} />

        <button onClick={fetchReport}>Get Report</button>
        <button onClick={handleDownload} style={{ background: '#28a745' }}>
          <FaDownload /> Download
        </button>
      </div>

      {/* TABLE */}
      {reportData.length > 0 && (
        <div className="farmer-report__table-container">
          <table className="farmer-report__table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Category</th>
                <th>Description</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {viewMode === 'regular'
                ? reportData.flatMap((g, i) =>
                    g.items.map((e, j) => (
                      <tr key={`${i}-${j}`}>
                        <td>{g.date}</td>
                        <td><span className={getCategoryClass(e.category)}>{e.category}</span></td>
                        <td>{e.description || '—'}</td>
                        <td>{e.amount}</td>
                      </tr>
                    ))
                  )
                : reportData.map((g, i) => (
                    <tr key={i}>
                      <td>{g.date}</td>
                      <td><span className="tag tag-mixed">Mixed</span></td>
                      <td>
                        <button className="expand-btn" onClick={() => toggleRow(i)}>
                          {expandedRows[i] ? <FaChevronUp /> : <FaChevronDown />} View Details
                        </button>
                        {expandedRows[i] && (
                          <ul className="description-list">
                            {g.descriptions.map((d, k) => <li key={k}>{d}</li>)}
                          </ul>
                        )}
                      </td>
                      <td><strong>{g.totalAmount}</strong></td>
                    </tr>
                  ))}

              {/* ✅ GRAND TOTAL ROW */}
              <tr className="grand-total-row">
                <td colSpan="3"><strong>Grand Total</strong></td>
                <td><strong>{grandTotal}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ExpensesReport;
